import { MeterBarTheme, styles, variants } from '../MeterBarStyles.css';
import { baseTheme } from './MeterBarBaseTheme.css';
import { multiVariantStyles } from './MeterBarVariants.css';

/*******************
 * Component Theme
 *******************/

const MeterBarRedwoodTheme: MeterBarTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { MeterBarRedwoodTheme };
